import { db } from "../firebase";
import { doc, updateDoc, increment } from "firebase/firestore";

export async function updateStorageInFirestore(uid, changeAmount) {
  const userDocRef = doc(db, "users", uid);
  await updateDoc(userDocRef, {
    storageUsed: increment(changeAmount),
  });
}
